import { render } from "./DbaWizardContainer.vue?vue&type=template&id=687a97c2"
import script from "./DbaWizardContainer.vue?vue&type=script&lang=js"
export * from "./DbaWizardContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__